import { CustomFields } from '../../models/CustomFields'

export interface IIsNoPlanFieldProps {
  isContr: boolean
}

export const getIsNoPlanField = ({ isContr }: IIsNoPlanFieldProps): string => {
  return isContr ? CustomFields.IsNoPlanContractual : CustomFields.IsNoPlan
}
